import { ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
export const ProductLevelTranslationKeyMap = {
  [FREE]: 'planBuilder.productLevel.FREE',
  [STARTER]: 'planBuilder.productLevel.STARTER',
  [PROFESSIONAL]: 'planBuilder.productLevel.PROFESSIONAL',
  [ENTERPRISE]: 'planBuilder.productLevel.ENTERPRISE'
};